module.exports = __webpack_public_path__ + "media/hallBgm.7823b965.mp3";